import { TOKENS, FONT_SANS } from 'Design/tokens'
import React from 'react'
import Plot from 'react-plotly.js'
import { GraphProps } from './Graph.types'
import { styled } from '@mui/material/styles'

const StyledPlot = styled(Plot)(() => ({
  width: '100%',
  height: '100%',
}))

export const hovertemplate = (
  xAxisName: string,
  traceName: string,
  xAxisUnit?: string,
  yAxisUnit?: string
) =>
  `   <b>${xAxisName}:  </b>%{x}${xAxisUnit ? xAxisUnit : ''}<br>` +
  `   <b>${traceName}:  </b>%{y}${yAxisUnit ? yAxisUnit : ''}<br><br>` +
  '<extra></extra>'

export const hovertemplateSKUGroup = (
  xAxisName: string,
  traceName: string,
  segmentName?: string,
  grpCode?: string
) =>
  `   <b>${xAxisName}:  </b>${segmentName ? segmentName : ''}<br>` +
  `   <b>${'SKU Grp code'}:  </b>${grpCode ? grpCode : ''}<br>` +
  `   <b>${traceName}:  </b>%{y}<br><br>` +
  '<extra></extra>'

export const Graph: React.FC<GraphProps> = ({
  onHover,
  onUnhover,
  revision,
  responsive = true,
  data,
  config,
  layout,
  className,
  title,
}: GraphProps) => {
  const defaultConfig = {
    displaylogo: false,
    responsive: true,
  }

  const styles = {
    plotBackgroundColor: TOKENS.surface0,
    lineColor: TOKENS.chartGrid,
    fontColor: TOKENS.chartInk,
    hoverBorderColor: TOKENS.line300,
    hoverBackgroundColor: TOKENS.surface0,
  }

  const properties = React.useMemo<any>(() => {
    return {
      data: data,
      layout: {
        title: {
          text: `<b>${title ? title : ''}<b>`,
          font: {
            family: FONT_SANS,
            size: 12,
            color: styles.fontColor,
          },
        },
        hovermode: 'closest',
        hoverlabel: {
          bordercolor: styles.hoverBorderColor,
          bgcolor: styles.hoverBackgroundColor,
          font: { color: styles.fontColor, family: FONT_SANS },
          style: {
            padding: '20px',
          },
        },
        font: { family: FONT_SANS, size: 11, color: styles.fontColor },
        margin: {
          l: 48,
          r: 8,
          b: 36,
          t: 8,
        },
        padding: {
          l: 50,
        },
        plotBackground: styles.plotBackgroundColor,
        ...layout,
        xaxis: {
          showgrid: false,
          nticks: 8,
          linewidth: 1,
          zeroline: true,
          showline: true,
          linecolor: TOKENS.chartAxis,
          tickfont: {
            family: FONT_SANS,
            size: 11,
            color: styles.fontColor,
          },
          ...layout?.xaxis,
        },
        yaxis: {
          showgrid: false,
          showline: true,
          linewidth: 1,
          zeroline: false,
          linecolor: TOKENS.chartAxis,
          tickfont: {
            family: FONT_SANS,
            size: 11,
            color: styles.fontColor,
          },
          ...layout?.yaxis,
        },
      },
      config: {
        ...defaultConfig,
        ...config,
      },
    }
  }, [data])

  return (
    <StyledPlot
      className={className}
      data={properties.data}
      config={properties.config}
      layout={properties.layout}
      useResizeHandler={responsive}
      onHover={onHover}
      onUnhover={onUnhover}
      revision={revision}
    />
  )
}
